import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone, ChevronDown } from "lucide-react";
import { BRAND, NAV_LINKS } from "../mock";
import { useBooking } from "../App";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { openBooking } = useBooking();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setMobileOpen(false), [location]);

  return (
    <>
      {/* Top offer strip */}
      <div className="bg-navy text-white text-xs sm:text-sm text-center py-2 px-4 font-medium">
        Get {BRAND.discount} OFF on your first order — use code{" "}
        <span className="bg-orange-brand text-white px-2 py-0.5 rounded-md font-bold ml-1">{BRAND.coupon}</span>
      </div>

      <header
        className={`sticky top-0 z-50 transition-all duration-300 ${
          scrolled ? "bg-white shadow-md" : "bg-white/95 backdrop-blur"
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between h-[80px]">
          <Link to="/" className="flex items-center shrink-0">
            <img src={BRAND.logo} alt="Laundryma - Motherly Wash" className="h-14 w-auto object-contain" />
          </Link>

          <nav className="hidden lg:flex items-center gap-7">
            {NAV_LINKS.map((l) => (
              <Link
                key={l.href}
                to={l.href}
                className="text-[15px] font-semibold text-navy/80 hover:text-orange-brand transition-colors relative group"
              >
                {l.label}
                <span className="absolute -bottom-1.5 left-0 w-0 h-0.5 bg-orange-brand transition-all duration-300 group-hover:w-full" />
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href={`tel:${BRAND.phone}`}
              className="hidden md:flex items-center gap-2 text-navy font-semibold text-sm hover:text-orange-brand transition-colors"
            >
              <Phone size={18} /> {BRAND.phoneDisplay}
            </a>
            <button
              onClick={openBooking}
              className="hidden sm:inline-flex items-center bg-orange-brand hover:bg-[#e0850f] text-white font-semibold text-sm px-5 py-2.5 rounded-full shadow-sm transition-colors"
            >
              Book a Service
            </button>
            <button className="lg:hidden text-navy" onClick={() => setMobileOpen((v) => !v)} aria-label="Menu">
              {mobileOpen ? <X size={26} /> : <Menu size={26} />}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {mobileOpen && (
          <div className="lg:hidden bg-white border-t border-gray-100 px-4 py-4 space-y-1 shadow-lg">
            {NAV_LINKS.map((l) => (
              <Link
                key={l.href}
                to={l.href}
                className="block py-2.5 text-navy font-semibold border-b border-gray-50"
              >
                {l.label}
              </Link>
            ))}
            <button
              onClick={openBooking}
              className="w-full mt-3 bg-orange-brand text-white font-semibold py-3 rounded-full"
            >
              Book a Service
            </button>
            <a href={`tel:${BRAND.phone}`} className="flex items-center justify-center gap-2 mt-2 text-navy font-semibold py-2">
              <Phone size={18} /> {BRAND.phoneDisplay}
            </a>
          </div>
        )}
      </header>
    </>
  );
};

export default Header;
